import { render } from "./Customer.vue?vue&type=template&id=768d79da&scoped=true&bindings={}"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=768d79da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-768d79da"

export default script